import { n as I, i as j, u as $, t as B, c as P, a as k, b as W, d as U, e as Q, f as Y, p as x, h as Z, g as q, j as G } from "./index-CQhmfoGb.js";
import { computed as M, shallowRef as w, toValue as E, watch as J, ref as K, readonly as X, watchEffect as ee, getCurrentInstance as te, onMounted as ne, hasInjectionContext as oe, unref as H, toRaw as ae } from "vue";
const O = k ? window : void 0, le = k ? window.document : void 0, z = k ? window.navigator : void 0;
function _(n) {
  var a;
  const s = E(n);
  return (a = s?.$el) != null ? a : s;
}
function b(...n) {
  const a = [], s = () => {
    a.forEach((t) => t()), a.length = 0;
  }, d = (t, o, r, u) => (t.addEventListener(o, r, u), () => t.removeEventListener(o, r, u)), p = M(() => {
    const t = W(E(n[0])).filter((o) => o != null);
    return t.every((o) => typeof o != "string") ? t : void 0;
  }), m = U(
    () => {
      var t, o;
      return [
        (o = (t = p.value) == null ? void 0 : t.map((r) => _(r))) != null ? o : [O].filter((r) => r != null),
        W(E(p.value ? n[1] : n[0])),
        W(H(p.value ? n[2] : n[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        E(p.value ? n[3] : n[2])
      ];
    },
    ([t, o, r, u]) => {
      if (s(), !t?.length || !o?.length || !r?.length)
        return;
      const f = G(u) ? { ...u } : u;
      a.push(
        ...t.flatMap(
          (y) => o.flatMap(
            (h) => r.map((g) => d(y, h, g, f))
          )
        )
      );
    },
    { flush: "post" }
  ), v = () => {
    m(), s();
  };
  return Q(s), v;
}
let N = !1;
function ve(n, a, s = {}) {
  const { window: d = O, ignore: p = [], capture: m = !0, detectIframe: v = !1, controls: t = !1 } = s;
  if (!d)
    return t ? { stop: I, cancel: I, trigger: I } : I;
  if (j && !N) {
    N = !0;
    const e = { passive: !0 };
    Array.from(d.document.body.children).forEach((i) => i.addEventListener("click", I, e)), d.document.documentElement.addEventListener("click", I, e);
  }
  let o = !0;
  const r = (e) => E(p).some((i) => {
    if (typeof i == "string")
      return Array.from(d.document.querySelectorAll(i)).some((l) => l === e.target || e.composedPath().includes(l));
    {
      const l = _(i);
      return l && (e.target === l || e.composedPath().includes(l));
    }
  });
  function u(e) {
    const i = E(e);
    return i && i.$.subTree.shapeFlag === 16;
  }
  function f(e, i) {
    const l = E(e), c = l.$.subTree && l.$.subTree.children;
    return c == null || !Array.isArray(c) ? !1 : c.some((T) => T.el === i.target || i.composedPath().includes(T.el));
  }
  const y = (e) => {
    const i = _(n);
    if (e.target != null && !(!(i instanceof Element) && u(n) && f(n, e)) && !(!i || i === e.target || e.composedPath().includes(i))) {
      if ("detail" in e && e.detail === 0 && (o = !r(e)), !o) {
        o = !0;
        return;
      }
      a(e);
    }
  };
  let h = !1;
  const g = [
    b(d, "click", (e) => {
      h || (h = !0, setTimeout(() => {
        h = !1;
      }, 0), y(e));
    }, { passive: !0, capture: m }),
    b(d, "pointerdown", (e) => {
      const i = _(n);
      o = !r(e) && !!(i && !e.composedPath().includes(i));
    }, { passive: !0 }),
    v && b(d, "blur", (e) => {
      setTimeout(() => {
        var i;
        const l = _(n);
        ((i = d.document.activeElement) == null ? void 0 : i.tagName) === "IFRAME" && !l?.contains(d.document.activeElement) && a(e);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), S = () => g.forEach((e) => e());
  return t ? {
    stop: S,
    cancel: () => {
      o = !1;
    },
    trigger: (e) => {
      o = !0, y(e), o = !1;
    }
  } : S;
}
function ie() {
  const n = w(!1), a = te();
  return a && ne(() => {
    n.value = !0;
  }, a), n;
}
function F(n) {
  const a = ie();
  return M(() => (a.value, !!n()));
}
const re = Symbol("vueuse-ssr-width");
function se() {
  const n = oe() ? q(re, null) : null;
  return typeof n == "number" ? n : void 0;
}
function ue(n, a = {}) {
  const { window: s = O, ssrWidth: d = se() } = a, p = F(() => s && "matchMedia" in s && typeof s.matchMedia == "function"), m = w(typeof d == "number"), v = w(), t = w(!1), o = (r) => {
    t.value = r.matches;
  };
  return ee(() => {
    if (m.value) {
      m.value = !p.value;
      const r = E(n).split(",");
      t.value = r.some((u) => {
        const f = u.includes("not all"), y = u.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), h = u.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let g = !!(y || h);
        return y && g && (g = d >= x(y[1])), h && g && (g = d <= x(h[1])), f ? !g : g;
      });
      return;
    }
    p.value && (v.value = s.matchMedia(E(n)), t.value = v.value.matches);
  }), b(v, "change", o, { passive: !0 }), M(() => t.value);
}
function R(n, a = {}) {
  const {
    controls: s = !1,
    navigator: d = z
  } = a, p = F(() => d && "permissions" in d), m = w(), v = typeof n == "string" ? { name: n } : n, t = w(), o = () => {
    var u, f;
    t.value = (f = (u = m.value) == null ? void 0 : u.state) != null ? f : "prompt";
  };
  b(m, "change", o, { passive: !0 });
  const r = Y(async () => {
    if (p.value) {
      if (!m.value)
        try {
          m.value = await d.permissions.query(v);
        } catch {
          m.value = void 0;
        } finally {
          o();
        }
      if (s)
        return ae(m.value);
    }
  });
  return r(), s ? {
    state: t,
    isSupported: p,
    query: r
  } : t;
}
function me(n = {}) {
  const {
    navigator: a = z,
    read: s = !1,
    source: d,
    copiedDuring: p = 1500,
    legacy: m = !1
  } = n, v = F(() => a && "clipboard" in a), t = R("clipboard-read"), o = R("clipboard-write"), r = M(() => v.value || m), u = w(""), f = w(!1), y = $(() => f.value = !1, p, { immediate: !1 });
  async function h() {
    let l = !(v.value && i(t.value));
    if (!l)
      try {
        u.value = await a.clipboard.readText();
      } catch {
        l = !0;
      }
    l && (u.value = e());
  }
  r.value && s && b(["copy", "cut"], h, { passive: !0 });
  async function g(l = E(d)) {
    if (r.value && l != null) {
      let c = !(v.value && i(o.value));
      if (!c)
        try {
          await a.clipboard.writeText(l);
        } catch {
          c = !0;
        }
      c && S(l), u.value = l, f.value = !0, y.start();
    }
  }
  function S(l) {
    const c = document.createElement("textarea");
    c.value = l ?? "", c.style.position = "absolute", c.style.opacity = "0", document.body.appendChild(c), c.select(), document.execCommand("copy"), c.remove();
  }
  function e() {
    var l, c, T;
    return (T = (c = (l = document?.getSelection) == null ? void 0 : l.call(document)) == null ? void 0 : c.toString()) != null ? T : "";
  }
  function i(l) {
    return l === "granted" || l === "prompt";
  }
  return {
    isSupported: r,
    text: u,
    copied: f,
    copy: g
  };
}
function he(n, a = {}) {
  var s, d;
  const p = w(!1), m = w(null);
  let v = 0, t = !0;
  if (k) {
    const o = typeof a == "function" ? { onDrop: a } : a, r = (s = o.multiple) != null ? s : !0, u = (d = o.preventDefaultForUnhandled) != null ? d : !1, f = (e) => {
      var i, l;
      const c = Array.from((l = (i = e.dataTransfer) == null ? void 0 : i.files) != null ? l : []);
      return c.length === 0 ? null : r ? c : [c[0]];
    }, y = (e) => {
      const i = H(o.dataTypes);
      return typeof i == "function" ? i(e) : i?.length ? e.length === 0 ? !1 : e.every(
        (l) => i.some((c) => l.includes(c))
      ) : !0;
    }, h = (e) => {
      const i = Array.from(e ?? []).map((T) => T.type), l = y(i), c = r || e.length <= 1;
      return l && c;
    }, g = () => /^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent) && !("chrome" in window), S = (e, i) => {
      var l, c, T, D, V, A;
      const C = (l = e.dataTransfer) == null ? void 0 : l.items;
      if (t = (c = C && h(C)) != null ? c : !1, u && e.preventDefault(), !g() && !t) {
        e.dataTransfer && (e.dataTransfer.dropEffect = "none");
        return;
      }
      e.preventDefault(), e.dataTransfer && (e.dataTransfer.dropEffect = "copy");
      const L = f(e);
      switch (i) {
        case "enter":
          v += 1, p.value = !0, (T = o.onEnter) == null || T.call(o, null, e);
          break;
        case "over":
          (D = o.onOver) == null || D.call(o, null, e);
          break;
        case "leave":
          v -= 1, v === 0 && (p.value = !1), (V = o.onLeave) == null || V.call(o, null, e);
          break;
        case "drop":
          v = 0, p.value = !1, t && (m.value = L, (A = o.onDrop) == null || A.call(o, L, e));
          break;
      }
    };
    b(n, "dragenter", (e) => S(e, "enter")), b(n, "dragover", (e) => S(e, "over")), b(n, "dragleave", (e) => S(e, "leave")), b(n, "drop", (e) => S(e, "drop"));
  }
  return {
    files: m,
    isOverDropZone: p
  };
}
const ce = {
  multiple: !0,
  accept: "*",
  reset: !1,
  directory: !1
};
function de(n) {
  if (!n)
    return null;
  if (n instanceof FileList)
    return n;
  const a = new DataTransfer();
  for (const s of n)
    a.items.add(s);
  return a.files;
}
function ye(n = {}) {
  const {
    document: a = le
  } = n, s = K(de(n.initialFiles)), { on: d, trigger: p } = P(), { on: m, trigger: v } = P();
  let t;
  a && (t = _(n.input) || a.createElement("input"), t.type = "file", t.onchange = (u) => {
    const f = u.target;
    s.value = f.files, p(s.value);
  }, t.oncancel = () => {
    v();
  });
  const o = () => {
    s.value = null, t && t.value && (t.value = "", p(null));
  }, r = (u) => {
    if (!t)
      return;
    const f = {
      ...ce,
      ...n,
      ...u
    };
    t.multiple = f.multiple, t.accept = f.accept, t.webkitdirectory = f.directory, Z(f, "capture") && (t.capture = f.capture), f.reset && o(), t.click();
  };
  return {
    files: X(s),
    open: r,
    reset: o,
    onCancel: m,
    onChange: d
  };
}
function ge(n = {}) {
  const {
    window: a = O,
    initialWidth: s = Number.POSITIVE_INFINITY,
    initialHeight: d = Number.POSITIVE_INFINITY,
    listenOrientation: p = !0,
    includeScrollbar: m = !0,
    type: v = "inner"
  } = n, t = w(s), o = w(d), r = () => {
    if (a)
      if (v === "outer")
        t.value = a.outerWidth, o.value = a.outerHeight;
      else if (v === "visual" && a.visualViewport) {
        const { width: f, height: y, scale: h } = a.visualViewport;
        t.value = Math.round(f * h), o.value = Math.round(y * h);
      } else m ? (t.value = a.innerWidth, o.value = a.innerHeight) : (t.value = a.document.documentElement.clientWidth, o.value = a.document.documentElement.clientHeight);
  };
  r(), B(r);
  const u = { passive: !0 };
  if (b("resize", r, u), a && v === "visual" && a.visualViewport && b(a.visualViewport, "resize", r, u), p) {
    const f = ue("(orientation: portrait)");
    J(f, () => r());
  }
  return { width: t, height: o };
}
export {
  ge as a,
  ye as b,
  he as c,
  ve as o,
  me as u
};
